"use client";

import { useEffect } from "react";
import Link from "next/link";
import * as Sentry from "@sentry/nextjs";
import { Home, ArrowLeft, Search } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function NotFound() {
  useEffect(() => {
    Sentry.captureMessage(`Page 404: ${window.location.pathname}`, {
      level: "warning",
      extra: { path: window.location.pathname },
    });
  }, []);

  return (
    <div className="relative min-h-screen w-full overflow-hidden bg-linear-to-b from-gray-950 via-black to-gray-950">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(212,168,75,0.03)_0%,transparent_50%)]" />

      <Navbar />

      <main className="relative z-10 min-h-screen flex items-center justify-center px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-7xl sm:text-8xl md:text-9xl font-bold text-white mb-6 tracking-tight">
            404
          </h1>

          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6">
            Page
            <span className="text-[#D4A84B]"> Not Found</span>
          </h2>

          <p className="text-lg md:text-xl text-white/60 font-light max-w-2xl mx-auto mb-12">
            The page you're looking for doesn't exist or has been moved.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              href="/"
              className="group inline-flex items-center gap-3 px-8 py-4 text-base font-medium text-white bg-white/5 border border-white/10 rounded-full hover:bg-white/10 hover:border-[#D4A84B]/50 transition-all duration-300 hover:shadow-[0_0_30px_rgba(212,168,75,0.15)]"
            >
              <Home className="w-5 h-5" />
              Go Home
            </Link>

            <Link
              href="https://country.club/blog"
              className="group inline-flex items-center gap-3 px-8 py-4 text-base font-medium text-black bg-white rounded-full hover:bg-[#D4A84B] transition-all duration-300 hover:shadow-[0_0_30px_rgba(212,168,75,0.3)]"
            >
              <Search className="w-5 h-5" />
              Browse Blog
            </Link>
          </div>

          <div className="mt-12">
            <Link
              href="/"
              className="inline-flex items-center gap-2 text-white/60 hover:text-[#D4A84B] transition-colors group"
            >
              <ArrowLeft className="w-4 h-4 transition-transform group-hover:-translate-x-1" />
              Back to previous page
            </Link>
          </div>
        </div>

        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(212,168,75,0.05)_0%,transparent_70%)] pointer-events-none" />
      </main>

      <Footer />
    </div>
  );
}
